/**
 * Seekers Dashboard Routes
 *
 * This route serves the parent/seeker dashboard via the global router.
 * It uses authentication and completion guards to ensure proper user access.
 *
 * Guards:
 * - requireSeeker: Ensures user is a parent (authentication)
 * - checkCorporateOnboarding: Ensures corporate parents have completed onboarding
 * - checkCareTypeRegistration: Ensures premium parents have selected a care type
 */
import Dashboard from '@/apps/account/seeker/Dashboard.vue';
import { requireSeeker } from '@/router/guards/authGuards';
import { checkCorporateOnboarding, checkCareTypeRegistration } from '@/router/guards/completionGuards';
import combineGuards from '../guards/helpers';

const seekersDashboardRoutes = [
  {
    path: '/account/seekers/dashboard',
    name: 'seekers-dashboard',
    component: Dashboard,
    beforeEnter: combineGuards([requireSeeker, checkCorporateOnboarding, checkCareTypeRegistration]),
  },
];

export default seekersDashboardRoutes;
